<ng-container>
  <mat-form-field class="mat-block" [ngClass]="{'l-updated-field': isOverriden}">
    <mat-select
      id="ddLongDate"
      [formControl]="ctrlLongDate"
      [placeholder]="placeholder"
      [required]="ctrlLongDate.hasError('required')"
    >
      <mat-option *ngFor="let longDate of longDateList" [value]="longDate"
        >{{longDate.format}}</mat-option
      >
    </mat-select>
    <mat-error
      id="errLongDate"
      class="error-message"
      *ngIf="(ctrlLongDate.dirty ||ctrlLongDate.touched)"
    >
      {{ "organization.create.section_3.long_date_required" | translate }}
    </mat-error>
  </mat-form-field>
</ng-container>
